import { Condition, FilterType } from 'types/GlobalKpiOption'

export type Order = 'asc' | 'desc'

export type Sort = {
  attribute: string
  direction: Order
}

export enum FileExtension {
  CSV = 'csv',
  XLSX = 'xlsx'
}

export type FilterBody = {
  attributeId: string
  condition: Condition
  value: string | null | (string | number | null)[]
  // Optional display label(s) parallel to `value`, for attributes whose
  // stored filter value is an id distinct from the human-readable name (e.g.
  // "handläggare"/agent segments). Same shape as `value`. Never use this for
  // querying — only for showing the filter to the user.
  display_value?: string | null | (string | number | null)[]
  type: FilterType
}

export type Filters = { [id: string]: FilterBody }

export type Severity = 'info' | 'error' | 'success' | 'warning'

export type StatusBannerLevel = 'info' | 'important'

export interface StatusBannerBody {
  customer_ids: string[]
  description: string
  link: string | null
  link_label: string | null
  append_email_to_link?: boolean
  level: StatusBannerLevel
  visible: boolean
  title: string
  only_admins: boolean
}

export interface StatusBannerData extends StatusBannerBody {
  id: string
}
